<template lang="pug">

    div

        //- Job wurde für den Lieferanten freigegeber
        div(v-if="isReleasedForSupplier")

            div(v-if='orderConfirmationModel')
                order-confirmation(
                    v-bind:file-model='fileModel'
                    v-bind:order-confirmation-model='orderConfirmationModel'
                    v-bind:price-model='priceModel'
                    v-bind:product-model='productModel'
                )

            //- Nicht auf Auftragsbestätigung von Lieferaten warten
            div(v-else-if='isOrderConfirmationRequired === false')
                .ui.icon.message
                    i.inbox.icon
                    .content: .header Lieferanten-AB wurde nicht angefordert

            //- Auf Auftragsbestätigung von Lieferaten warten
            div(v-else-if='isOrderConfirmationRequired === true')
                order-confirmation-request-info-message(
                    v-bind:upload-model='uploadModel'
                    v-bind:order-confirmation-request-model='orderConfirmationRequestModel'
                )

            //- Entscheiden ob auf Auftragsbestätigung von Lieferaten gewartet werden soll
            div(v-else)
                order-confirmation-buttons(v-bind:price-model='priceModel')

        //- Job wurde noch nicht für den Lieferanten freigegeber
        div(v-else)
            release-job-for-supplier-button(v-bind:job-model='jobModel' v-bind:product-model='productModel')

</template>

<script>
    import * as R from 'ramda'
    import store from '@/store'
    import OrderConfirmation from '@/components/products/production-costs/OrderConfirmation'
    import OrderConfirmationButtons from '@/components/products/production-costs/OrderConfirmationButtons'
    import OrderConfirmationRequestInfoMessage from '@/components/products/production-costs/OrderConfirmationRequestInfoMessage'
    import ReleaseJobForSupplierButton from '@/components/products/production-costs/ReleaseJobForSupplierButton'

    //noinspection JSUnusedLocalSymbols,JSUnusedGlobalSymbols

    export default {

        async beforeRouteEnter(to, from, next) {
            // Produkt laden
            const productModel = await store.dispatch('products/loadOne', { id: to.params.id })

            // akzeptierten Preis laden
            const priceModel = await store.dispatch('prices/loadOne', { id: productModel.price })

            const [ offerModel, orderConfirmationRequestModel, orderConfirmationModel ] = await Promise.all([

                // Angebot zu Preis laden
                store.dispatch('offers/loadOne', { id: priceModel.offer }),

                // ggf. Auftragsbestätigung-Request laden
                R.ifElse(R.propIs(Number, 'orderConfirmationRequest'),
                    ({ orderConfirmationRequest }) => store.dispatch('orderConfirmationRequests/loadOne', { id: orderConfirmationRequest }),
                    () => Promise.resolve()
                )(priceModel),

                // ggf. Auftragsbestätigung laden
                R.ifElse(R.propIs(Number, 'orderConfirmation'),
                    ({ id }) => store.dispatch('orderConfirmations/loadOneByPriceId', { priceId: id }),
                    () => Promise.resolve()
                )(priceModel),

            ])

            await Promise.all([

                // Job laden
                await store.dispatch('jobs/loadOne', { id: offerModel.job }),

                // ggf. Upload-Link laden
                R.when(R.is(Object),
                    ({ upload }) => store.dispatch('uploads/loadOne', { id: upload })
                )(orderConfirmationRequestModel),

                // ggf. Auftragsbestätigung-File laden
                R.when(R.is(Object),
                    ({ file }) => store.dispatch('files/loadOne', { id: file }),
                )(orderConfirmationModel),

            ])

            // Routing
            next()
        },

        components: {
            OrderConfirmation, OrderConfirmationButtons, OrderConfirmationRequestInfoMessage,
            ReleaseJobForSupplierButton
        },

        computed: {

            fileModel() {
                const fileId = R.prop('file', this.orderConfirmationModel)
                return store.getters['files/byId'](fileId)
            },

            isReleasedForSupplier() {
                return ['ACCEPTED', 'IN_PRODUCTION', 'DELIVERED', 'QA', 'COMPLETED'].includes(R.prop('status', this.jobModel))
            },

            isOrderConfirmationRequired() {
                return R.prop('isOrderConfirmationRequired', this.priceModel)
            },

            jobModel() {
                return store.getters['jobs/byId'](this.offerModel.job)
            },

            offerModel() {
                return store.getters['offers/byId'](this.priceModel.offer)
            },

            orderConfirmationModel() {
                const id = R.prop('orderConfirmation', this.priceModel)
                return store.getters['orderConfirmations/byId'](id)
            },

            orderConfirmationRequestModel() {
                const id = R.prop('orderConfirmationRequest', this.priceModel)
                return store.getters['orderConfirmationRequests/byId'](id)
            },

            priceModel() {
                return store.getters['prices/byId'](this.productModel.price)
            },

            productId() {
                return Number(this.$route.params.id)
            },

            productModel() {
                return store.getters['products/byId'](this.productId)
            },

            uploadModel() {
                const uploadId = R.prop('upload', this.orderConfirmationRequestModel)
                return store.getters['uploads/byId'](uploadId)
            },

        },

    }

</script>


